<template>
  <div class="reset-password-page">
    <div class="reset-container">
      <h1>{{ $t('login.resetPassword.title') }}</h1>
      
      <div v-if="success" class="success-message">
        {{ $t('login.resetPassword.success') }}
        <!-- O login mora em `/` — `/login` nunca foi rota registrada. -->
        <router-link to="/">{{ $t('login.resetPassword.backToLogin') }}</router-link>
      </div>

      <form v-else @submit.prevent="handleSubmit" class="reset-form">
        <div v-if="error" class="error-alert">{{ error }}</div>

        <div class="input-group">
          <label for="password">{{ $t('login.resetPassword.newPassword') }}</label>
          <div class="password-input">
            <input 
              :type="showPassword ? 'text' : 'password'" 
              id="password" 
              v-model="password"
              required
              minlength="6"
            >
            <button type="button" class="toggle-password" @click="showPassword = !showPassword">
              <i class="fas" :class="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
            </button>
          </div>
        </div>

        <div class="input-group">
          <label for="confirmPassword">{{ $t('login.resetPassword.confirmPassword') }}</label>
          <input 
            type="password" 
            id="confirmPassword" 
            v-model="confirmPassword"
            required
          >
          <span v-if="!passwordsMatch" class="error-message">
            {{ $t('login.resetPassword.passwordMismatch') }}
          </span>
        </div>

        <button type="submit" class="submit-btn" :disabled="!passwordsMatch">
          {{ $t('login.resetPassword.submit') }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { playerService } from '../services/player';

export default {
  name: 'ResetPassword',
  data() {
    return {
      password: '',
      confirmPassword: '',
      error: null,
      success: false,
      showPassword: false
    }
  },
  computed: {
    passwordsMatch() {
      return this.password === this.confirmPassword;
    },
    resetCode() {
      return this.$route.query.code;
    }
  },
  methods: {
    async handleSubmit() {
      if (!this.passwordsMatch) return;
      
      try {
        await playerService.resetPassword(this.resetCode, this.password);
        this.success = true;
      } catch (error) {
        // 400 do V2 = código inválido, já usado ou vencido.
        this.error = error.response?.data?.message ||
                    error.response?.data?.error?.message ||
                    error.message ||
                    this.$t('login.resetPassword.error');
      }
    }
  },
  created() {
    // Sem código na URL não há o que resetar — de volta ao login, que é `/`.
    if (!this.resetCode) {
      this.$router.push('/');
    }
  }
}
</script>

<style scoped>
.reset-password-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #1a4572 0%, #062847 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.reset-container {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  padding: 2rem;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  width: 90%;
  max-width: 400px;
}

h1 {
  color: #fff;
  text-align: center;
  margin-bottom: 2rem;
}

.reset-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.input-group label {
  color: #fff;
}

.input-group input {
  padding: 0.75rem;
  border: none;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  width: 100%;
}

.submit-btn {
  padding: 1rem;
  background: linear-gradient(45deg, #2196f3, #00bcd4);
  border: none;
  border-radius: 10px;
  color: #fff;
  cursor: pointer;
  transition: transform 0.3s ease, opacity 0.3s ease, background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease, box-shadow 0.3s ease, filter 0.3s ease;
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.error-message {
  color: #ff6b6b;
  font-size: var(--f-1);
}

.success-message {
  color: #4caf50;
  text-align: center;
  padding: 1rem;
}

.success-message a {
  display: block;
  margin-top: 1rem;
  color: #2196f3;
  text-decoration: none;
}

.password-input {
  position: relative;
}

.toggle-password {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
}
</style>
